var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToogleMenuAlgar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 18.118,
    viewBox: "0 0 28 18.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 28,
    height: 18.118,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 18.118,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A650",
    fillRule: "evenodd",
    d: "M1.64705882 0h24.70588236C27.26197768 0 28 .73802231 28 1.64705882c0 .90903651-.73802231 1.64705883-1.64705882 1.64705883H1.64705882C.73802232 3.29411765 0 2.55609533 0 1.64705882 0 .73802232.73802231 0 1.64705882 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A650",
    fillRule: "evenodd",
    d: "M1.64705882 7.4117647h24.70588236C27.26197768 7.4117647 28 8.14978703 28 9.05882354c1e-8.90903649-.73802229 1.6470588-1.6470588 1.64705882H1.64705882C.73802232 10.70588235 0 9.96786004 0 9.05882353 0 8.14978702.73802231 7.4117647 1.64705882 7.4117647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A650",
    fillRule: "evenodd",
    d: "M1.64705882 14.82352941h13.1764706c.9090365 0 1.64705882.73802231 1.64705882 1.64705883 0 .9090365-.73802232 1.64705882-1.64705883 1.64705882H1.64705882C.73802232 18.11764706 0 17.37962475 0 16.47058824c0-.90903652.73802231-1.64705883 1.64705882-1.64705883z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToogleMenuAlgar);
export default __webpack_public_path__ + "static/media/toogle_menu_algar.9ded9cd490119402a46b9fd9664ff41b.svg";
export { ForwardRef as ReactComponent };